import { AUTH_ROLES } from "@/constants/auth";

/**
 * Nav URLs allowed for a sidebar "view" role. Superadmin is handled separately (all items).
 *
 * @param {string|null|undefined} role
 * @returns {Set<string>|null} null when superadmin (caller shows all nav items)
 */
export function getAvailableNavUrlsForRole(role) {
  const navRole = String(role ?? "")
    .trim()
    .toLowerCase();
  if (navRole === AUTH_ROLES.SUPERADMIN) return null;

  switch (navRole) {
    case AUTH_ROLES.CAMPAIGN:
      return new Set(["/properties", "/parcel-search", "/opportunities", "/campaigns"]);
    case AUTH_ROLES.INVESTOR:
      // HAI-1096: investor view has no Properties menu item; properties are only reachable via opportunities/deals.
      return new Set(["/parcel-search", "/opportunities"]);
    case AUTH_ROLES.REALTOR:
      return new Set(["/properties", "/campaigns", "/parcel-search"]);
    case AUTH_ROLES.HOMEOWNER:
    case AUTH_ROLES.CONTRACTOR:
    case AUTH_ROLES.WHOLESALER:
    case AUTH_ROLES.USER:
      return new Set(["/properties"]);
    default:
      return new Set();
  }
}

/**
 * Whether the Properties nav item (and PropertyBackgroundSync) should be active for this role/view.
 *
 * @param {string|null|undefined} role
 * @returns {boolean}
 */
export function canAccessPropertiesNav(role) {
  const urls = getAvailableNavUrlsForRole(role);
  if (urls === null) return true;
  return urls.has("/properties");
}
